<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="批量维护交期"
      width="1000px"
      append-to-body
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="purchaseDetail"
        class="form"
        label-width="110px"
        style="height: 200px;">
      <el-row>
        <el-col :span="12">
          <el-form-item label="类型">
            <el-select v-model="purchaseDetail.finalDeliveryType">
              <el-option label="通知送货" value="通知送货" default/>
              <el-option label="采购延期" value="采购延期"/>
              <el-option label="计划同意延期" value="计划同意延期"/>
              <el-option label="其它" value="其它"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最终交期">
            <el-date-picker
                v-model="purchaseDetail.finalDeliveryDate"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="请选择"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="描述">
            <el-input
                v-model="purchaseDetail.finalDeliveryDesc"
                type="textarea"
                style="min-height: 80px;"
                autosize
                placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        disabled: "",
        purchaseDetail: {
          ids: [],
          pkid: 0,
          finalDeliveryDate: "",
          finalDeliveryType: "通知送货",
          finalDeliveryDesc: "",
        },
      };
    },

    methods: {
      open(row) {
        this.purchaseDetail.ids = [];
        this.dialogVisible = true;
        if (row) {
          row.forEach((item) => {
            this.purchaseDetail.ids.push(item.pkid);
          });
        }
      },
      inputHandle(row, index) {
        this.$set(this.model.detailVOS, index, row);
      },
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "purchaseOrderDetails/batchUpdateDeliveryDate", this.purchaseDetail)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 8px;
  padding-bottom: 5px;
}
</style>
